import { TextField, FormControl } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  marginTop: '12px',
  width: '100%',

  '& .MuiInputLabel-root': {
    backgroundColor: 'transparent',
    color: `${theme.palette.primary.main} !important`,
    fontWeight: 'bold',
    '&.MuiInputLabel-shrink': {
      backgroundColor: theme.palette.background.paper || 'white',
      padding: '0 4px',
      transform: 'translate(14px, -9px) scale(0.75)',
      color: `${theme.palette.primary.main} !important`,
    },
    '&.Mui-focused': {
      color: `${theme.palette.primary.main} !important`,
    },
    '&.MuiFormLabel-filled': {
      color: `${theme.palette.primary.main} !important`,
    },
  },

  '& .MuiSelect-select': {
    paddingTop: '14px',
    paddingBottom: '14px',
  },

  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: theme.palette.primary.main,
      borderWidth: 2,
      opacity: 0.8,
    },
    '&:hover fieldset': {
      borderColor: theme.palette.primary.main,
      borderWidth: 3,
      opacity: 0.6,
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.main,
      borderWidth: 3,
    },
  },

  '@media (max-width: 600px)': {
    marginTop: '8px',
    '& .MuiInputLabel-root': {
      fontSize: '14px',
    },
  },
}));

const CustomTextField = ({
  label,
  id,
  name,
  value,
  onChange,
  sx = {},
  size = 'medium',
  variant = 'outlined',
  shrinkLabel = true,
  ...props
}) => {
  const SIZES = {
    small: { height: '40px', fontSize: '14px', labelSize: '12px' },
    medium: { height: '56px', fontSize: '18px', labelSize: '18px' },
    large: { height: '64px', fontSize: '18px', labelSize: '16px' },
    xlarge: { height: '72px', fontSize: '20px', labelSize: '18px' },
  };

  const sizeConfig = SIZES[size] || SIZES.medium;

  const baseStyles = {
    '& .MuiOutlinedInput-root': {
      height: sizeConfig.height,
      fontSize: sizeConfig.fontSize,
    },
    '& .MuiInputBase-input': {
      height: sizeConfig.height,
      padding: '0 14px',
      fontSize: sizeConfig.fontSize,
      display: 'flex',
      alignItems: 'center',
      boxSizing: 'border-box',
    },
    '& .MuiInputBase-input[type="date"]': {
      paddingRight: '0px',
      '&::-webkit-datetime-edit': {
        paddingRight: 0,
        marginRight: 0,
      },
      '&::-webkit-datetime-edit-fields-wrapper': {
        paddingRight: 0,
        marginRight: 0,
      },
      '&::-webkit-inner-spin-button': {
        display: 'none',
      },
      '&::-webkit-calendar-picker-indicator': {
        cursor: 'pointer',
        marginLeft: '-15px',
        paddingLeft: 0,
      },
    },
    '& .MuiInputLabel-root': {
      fontSize: sizeConfig.labelSize,
      fontWeight: 'bold',
    },
    ...sx,
  };

  return (
    <StyledFormControl sx={baseStyles}>
      <TextField
        label={label}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        variant={variant}
        InputLabelProps={{
          shrink: shrinkLabel,
        }}
        {...props}
      />
    </StyledFormControl>
  );
};

export default CustomTextField;
